import React from "react";
import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import { useSnapshotReport } from "./useSnapshotReport";

/**
 * Self-contained pair of "Snapshot Report" buttons (PDF + Word) for a single
 * inspection. Drop into any list/table row; renders its own hidden print
 * markup.
 */
const SnapshotReportButtons = ({ irNdx, size = "small" }) => {
  const { generateReport, generating, printMarkup } = useSnapshotReport();

  const busy = (format) =>
    generating?.irNdx === irNdx && generating?.format === format;

  return (
    <>
      <Tooltip title="Snapshot Report (PDF)">
        <span>
          <IconButton
            size={size}
            color="primary"
            disabled={!!generating}
            onClick={() => generateReport(irNdx, "pdf")}
            aria-label="Download inspection snapshot report as PDF"
          >
            {busy("pdf") ? (
              <CircularProgress size={20} />
            ) : (
              <PictureAsPdfIcon fontSize={size} />
            )}
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Snapshot Report (Word)">
        <span>
          <IconButton
            size={size}
            color="primary"
            disabled={!!generating}
            onClick={() => generateReport(irNdx, "docx")}
            aria-label="Download inspection snapshot report as Word document"
          >
            {busy("docx") ? (
              <CircularProgress size={20} />
            ) : (
              <DescriptionIcon fontSize={size} />
            )}
          </IconButton>
        </span>
      </Tooltip>
      {printMarkup}
    </>
  );
};

export default SnapshotReportButtons;
